const FUNCTIONS_BASE =
  process.env.REACT_APP_FUNCTIONS_BASE_URL ||
  'https://australia-southeast1-piatto-97499.cloudfunctions.net';

/**
 * Build an ENDPOINTS object for any backend URL.
 * Used by RegionContext to create region-specific endpoints.
 */
export const buildEndpoints = (base) => ({
  // User / payment endpoints (Express app)
  userNotify: `${base}/user/user-notify`,
  refund: `${base}/user/refund`,

  // Computer vision
  cvUploadFile: `${base}/computervision/uploadFile`,

  // Business
  business: (bizId) => `${base}/business/${bizId}`,
  businessOrder: (bizId) => `${base}/business/${bizId}/order`,

  // Web ordering payment (guest checkout — no Stripe customer required)
  webPaymentIntent: `${base}/user/web-payment-intent`,
  // Releases a PENDING_ON_APPROACH order when the customer is near the venue
  releaseApproachOrder: `${base}/user/release-approach-order`,

  // Venue claim flow
  logClaimPageVisit: `${base}/logClaimPageVisit`,
  initiateClaim: `${base}/initiateClaim`,
  completeClaim: `${base}/completeClaim`,
  searchVenueForClaim: `${base}/searchVenueForClaim`,
  resendClaimEmail: `${base}/resendClaimEmail`,
  verifyPhone: `${base}/verifyPhone`,
  verifyEmailSend: `${base}/verifyEmailSend`,
  verifyEmailConfirm: `${base}/verifyEmailConfirm`,
  uploadVerificationDocument: `${base}/uploadVerificationDocument`,

  // Brand claim flow
  initiateBrandClaim: `${base}/initiateBrandClaim`,
  completeBrandClaim: `${base}/completeBrandClaim`,

  // Admin
  getAdminReviewQueue: `${base}/getAdminReviewQueue`,
  approveVenueClaim: `${base}/approveVenueClaim`,
  rejectVenueClaim: `${base}/rejectVenueClaim`,
  sendStripeOnboarding: `${base}/sendStripeOnboarding`,
  scrapeVenueMenu: `${base}/scrapeVenueMenu`,
  getVenuePhoto: `${base}/getVenuePhoto`,

  // CV Menu Bridge
  processMenuCV: `${base}/processMenuCV`,
  bulkProcessMenuCV: `${base}/bulkProcessMenuCV`,
  adminVerifyMenu: `${base}/adminVerifyMenu`,

  // Venue import
  bulkImportVenues: `${base}/bulkImportVenues`,
  recalculateStats: `${base}/recalculateStats`,

  // Email scraper
  controlEmailScrape: `${base}/controlEmailScrape`,

  // Venue outreach
  notifyUnclaimedVenues: `${base}/notifyUnclaimedVenues`,
  sendFollowUpEmails: `${base}/sendFollowUpEmails`,

  // Alt text generation
  generateAltText: `${base}/generateAltText`,

  // Unsubscribe
  handleUnsubscribe: `${base}/handleUnsubscribe`,

  // Floor Plan
  floorplan: (bizId, floor) => `${base}/floorplan/${bizId}/${floor}`,
  floorplanList: (bizId) => `${base}/floorplan/${bizId}`,

  // Stripe self-service onboarding
  enablePayments: `${base}/stripeOnboarding/enable-payments`,
  resumeOnboarding: `${base}/stripeOnboarding/resume-onboarding`,
  paymentStatus: (venueId) => `${base}/stripeOnboarding/payment-status/${venueId}`,
  stripeDashboard: `${base}/stripeOnboarding/stripe-dashboard`,
});

// Default AU endpoints (backward compatible)
const ENDPOINTS = buildEndpoints(FUNCTIONS_BASE);

export { FUNCTIONS_BASE, ENDPOINTS };
export default ENDPOINTS;
